import React from 'react';
import { Navigate } from 'react-router-dom';

const RoleBasedRoute = ({ children, restrictedRoles = [] }) => {
    const storedUser = JSON.parse(localStorage.getItem('user'));
    const userRole = storedUser?.role;

    if (restrictedRoles.includes(userRole)) {
        // If restricted, redirect to a safe page based on role
        if (userRole === 'ward') {
            return <Navigate to="/preferences" replace />;
        }
        // Default fallback for other restricted roles (if any in future)
        return <Navigate to="/" replace />;
    }

    return children;
};

export default RoleBasedRoute;
